import { createSelector } from '@reduxjs/toolkit';

import { AttributeTableItem } from 'src/containers/ProjectDiagram/components/attributesTable/types';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { classDraftChangesSelector } from 'src/selectors/draftClass';
import { projectAttributeRangesByIriSelector } from 'src/selectors/projectAttributeRangesByIri';
import { projectClassAttributesSelector } from 'src/selectors/projectClassAttributes';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import * as copy from 'src/templates/copy';

export const projectClassAttributeItemsSelector = (
  projectId: string,
  classIri: string
) =>
  createSelector(
    projectClassAttributesSelector(projectId, classIri),
    projectAttributeRangesByIriSelector(projectId),
    projectLabelsByIriSelector(projectId),
    classDraftChangesSelector(projectId, classIri),
    (classAttributesByIri, rangesByIri, labelsByIri, { modifiedAttributes }) =>
      Object.values(classAttributesByIri).map<
        AttributeTableItem & { depth: number }
      >(({ depth, value }) => ({
        depth,
        highlighted: modifiedAttributes.has(value),
        ranges: rangesByIri[value] || [],
        text: getLabelForIri(
          labelsByIri,
          value,
          copy.components.projectDiagram.modelConceptAttribute.new
        ),
        value,
      }))
  );
